module.exports = __webpack_public_path__ + "static/img/icon-6.e3dc427.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/icon-6.png
// module id = V2QW
// module chunks = 1